<template>
  <div class="bblayout" :class="{ 'white-layout': whiteLayout }">
    <component
      v-if="hasAliApp"
      :is="'script'"
      type="text/javascript"
      src="https://appx/web-view.min.js"
    ></component>
    <div class="bblayout__content">
      <div class="guidelines">
        <div class="guidelines__tab">
          <div
            class="guidelines__tabitem"
            v-for="(item, index) in tabList"
            :key="index"
            :class="{ 'guidelines__tabitem--active': index === tabIndex }"
            @click="tabIndex = index"
          >
            {{ item.name }}
          </div>
        </div>
        <template v-if="tabIndex === 0">
          <div class="guidelines__title"><div data-title="最早取车时间"></div></div>
          <div class="guidelines__card">
            <div>在线自主下单，至少需提前24小时下单。</div>
            <div>订阅网点营业时间：9:00-20:00</div>
            <div class="transparent-font small-font">
              *若有今明两天<span class="orange-font">临取</span
              >需求，您可与下方订阅体验官企业微信沟通，在车辆库存允许的情况下为您改派订单，但无法保证车辆整备及电量。
            </div>
          </div>
          <div class="guidelines__title"><div data-title="可选车型"></div></div>
          <div class="guidelines__card">
            <div >极氪001、极氪007、极氪007GT、极氪009、极氪X、极氪7X、极氪MIX</div>
          </div>
          <div class="guidelines__title"><div data-title="服务城市及用车周期"></div></div>
          <div class="guidelines__card">
            <div class="has-blurbar">短租（ 3天起订 ）</div>
            <div class="">
              <span style="font-weight: 500;">服务覆盖城市：</span><br />
              杭州、上海、成都、北京、深圳<br />
            </div>
            <div class="transparent-font small-font">
              *法定节假日订阅周期以具体政策为准。
            </div>
            <div class="has-blurbar">长租（ 月订起订 ）</div>
            <div class="">
              上述城市及其周边300KM以内的城市，支持以月为时间单位的长期订阅用车（如宁波、义乌等）。
            </div>
            <div class="transparent-font small-font">
              *月订用户可享受距离交通枢纽30公里内地址的<span class="orange-font"
                >免费上门</span
              >取送车服务，若有需要可扫描下方订阅体验官企业微信了解详情。
            </div>
          </div>
          <div class="guidelines__title"><div data-title="下单平台"></div></div>
          <div class="guidelines__table">
            <div>可在支付宝、微信、各大应用市场上搜索“极氪订阅”进行下单：</div>
            <img
              class="mgt"
              v-if="whiteLayout"
              src="@/static/image/tab_0_w.png"
            />
            <img class="mgt" v-else src="@/static/image/tab_0_b.png" />
          </div>
        </template>
        <template v-if="tabIndex === 1">
          <div class="guidelines__title"><div data-title="证件要求"></div></div>
          <div class="guidelines__card">
            <div class="has-blurbar">身份证</div>
            <div>本人大陆二代身份证，证件剩余有效期≥1个月</div>
            <div class="has-blurbar">驾驶证</div>
            <div>本人过实习期（满一年）驾驶证，证件剩余有效期≥1个月</div>
            <div class="small-font transparent-font">
              *如您未携带实体驾照，可登录12123获取电子驾照并于取车时提供给管家用于核验。
            </div>
          </div>
          <div class="guidelines__title"><div data-title="电量规则"></div></div>
          <div class="guidelines__card">
            <div class="has-blurbar">网点取车</div>
            <div>取车时，一般情况下交付给您的车辆电量(SOC)≥80%</div>
            <div class="transparent-font small-font">*临时取车订单不保证车辆电量。</div>
            <div class="has-blurbar">网点还车</div>
            <div>
              还车时，您应确保车辆电量（SOC）≥50%，如车辆电量(SOC)＜50%，您须支付50元充电服务费。
            </div>
            <div class="transparent-font small-font">
              *若您已购买升级出行服务权益包，则有机会享受免充电服务费权益。
            </div>
          </div>
          <div class="guidelines__title"><div data-title="限行规则"></div></div>
          <div class="guidelines__card">
            <div class="has-blurbar">里程限制</div>
            <div>订阅期间车辆无行驶里程限制。</div>
            <div class="has-blurbar">禁行区域</div>
            <div class="">
              1、订阅用车期间车辆应仅在中华人民共和国境内（不含香港、澳门、台湾地区）且非限行限号区域（以各地限行规则/政策为准）内行驶或使用。
            </div>
            <div class="">
              2、原则上不允许订阅车辆驶入西藏全域、新疆全域、云南省泸沽湖、云南省瑞丽市、云南省西双版纳州勐海县、广西壮族自治区防城港、四川省甘孜州、阿坝州、凉山州等区域，如需驶入该等区域，须在取车前告知出租方且获得出租方的书面同意并另行缴纳风险保证金。
            </div>
          </div>
        </template>
        <template v-if="tabIndex === 2">
          <div class="guidelines__title"><div data-title="押金政策"></div></div>
          <div class="guidelines__card-transparent">
            订阅收费采取“一价全包”模式，车辆押金与违章押金可通过现金实付或芝麻信用免押支付。具体车型押金费用及免押标准如下：
          </div>
          <div class="guidelines__table">
            <img v-if="whiteLayout" src="@/static/image/tab_2_w.png" />
            <img v-else src="@/static/image/tab_2_b.png" />
          </div>
          <div class="guidelines__card">
            <div class="has-blurbar">押金退回/解冻时间</div>
            <div>
              押金支付方式为芝麻信用免押的订单，如还车后车辆审核通过无异常，无未支付款项且15个工作日后查无未处理违章，免押订单将自动关闭相应额度将自动释放；
            </div>
            <div>
              押金支付方式为现金实付的订单，如还车后车辆审核通过无异常、无未支付款项，车辆押金将自动退还，15个工作日后查无未处理违章，违章押金将自动退还。
            </div>
          </div>
          <div class="guidelines__title"><div data-title="风险保证金"></div></div>
          <div class="guidelines__card">
            <div class="has-blurbar">收费规则</div>
            <div>
              如承租方需驾驶车辆进入西藏全域、新疆全域、云南省泸沽湖、云南省瑞丽市、云南省西双版纳州勐海县，广西壮族自治区防城港、四川省甘孜州、阿坝州、凉山州等区域的，须在取车前告知出租方且获得出租方的书面同意并另行缴纳风险保证金后方可取车，否则出租方有权拒绝承租方的取车需求。
            </div>
            <div class="has-blurbar">收费标准</div>
            <div>
              订阅车辆车型为极氪001/极氪X/极氪007/极氪007GT/极氪7X/极氪MIX时，须缴纳10000元风险保证金；订阅车辆车型为极氪009时，须缴纳20000元风险保证金。
            </div>
            <div class="has-blurbar">退费时间</div>
            <div>风险保证金将在您用车结束，还车后3个工作日内退回。</div>
            <div class="has-blurbar">补充说明</div>
            <div>
              若您未缴纳风险保证金但前往了上述禁行规则限制区域，极氪订阅有权随时强制收回车辆，强制收回车辆时产生的相关费用将由您承担，若在还车后发现您的订阅期间行驶记录包含上述禁行规则限制区域的，极氪订阅有权要求您一次性支付【5000元】违约金。
            </div>
          </div>
        </template>
        <template v-if="tabIndex === 3">
          <div class="guidelines__title"><div data-title="订单修改"></div></div>
          <div class="guidelines__table">
            <img v-if="whiteLayout" src="@/static/image/tab_3_w.png" />
            <img v-else src="@/static/image/tab_3_b.png" />
          </div>
          <div class="guidelines__table">
            <img v-if="whiteLayout" src="@/static/image/tab_31_w.png" />
            <img v-else src="@/static/image/tab_31_b.png" />
          </div>
          <div class="transparent-font guidelines__card-transparent small-font">
            *其他未尽事宜详见《汽车订阅租赁合同》
          </div>
        </template>
        <template v-if="tabIndex === 4">
          <div class="guidelines__title"><div data-title="出行权益"></div></div>
          <div class="guidelines__table">
            <img v-if="whiteLayout" src="@/static/image/tab_05_w.png" />
            <img v-else src="@/static/image/tab_05_b.jpg" />
          </div>
          <div class="transparent-font guidelines__card-transparent small-font">
            *极氪订阅默认提供基础出行服务，您可根据个人需要订阅升级出行服务权益包，具体规则请以《汽车订阅租赁合同》为准。
          </div>
          <div class="guidelines__title"><div data-title="事故处理"></div></div>
          <div class="guidelines__table">
            <img v-if="whiteLayout" src="@/static/image/tab_51_w.png" />
            <img v-else src="@/static/image/tab_51_b.jpg" />
          </div>
        </template>
        <div class="guidelines__qrcode" v-if="!hideQrcode">
          <img src="@/static/image/faq2page-zeekr-qrcode.jpg" />
          <div>
            如您下单过程中遇到任何疑问，可截图保存图片
          </div>
          <div>
            扫码添加@订阅体验官 企业微信
          </div>
        </div>
        <div class="guidelines__btn">
          <div class="guidelines__tosub" @click="toSub">立即订阅</div>
        <div class="guidelines__hint transparent-font">
          感谢您选择极氪订阅，如您需了解关于订阅租赁汽车更全面的内容，可查阅《汽车订阅租赁合同》，祝您用车愉快!
        </div>
        </div>
        
      </div>
    </div>
  </div>
</template>
<script setup>
import { ref, onMounted } from "vue";
import Ditto from "@zeekr-f2e/zeekr-ditto";
import { useRoute } from "vue-router";
const route = useRoute();

const tabList = [
  { name: "下单指引" },
  { name: "用车须知" },
  { name: "押金政策" },
  { name: "订单修改" },
  { name: "出行权益" },
];
const tabIndex = ref(0);
const hideQrcode = ref(false);
const whiteLayout = ref(false);
const hasAliApp = ref(false);
// 前往订阅页
const toSub = () => {
  const ua = window.navigator.userAgent.toLowerCase();
  const isIos =
    /(ios|ipad|iphone)/.test(ua) ||
    (ua.indexOf("macintosh") > -1 && "ontouchend" in document);
  if (hasAliApp.value) {
    // 支付宝内
    // my.navigateTo({ url: "/PlaceOrder/index" });
    my.navigateBack();
    // 当whiteandhideqr有值,视为从支付宝新手指引页面进入
    if (route.query.whiteandhideqr) {
      my.redirectTo({ url: "/pages/index/index" });
    }
  } else if (ua.match(/MicroMessenger/i) == "micromessenger") {
    // 微信内
    if (!isIos) {
      wx.miniProgram.navigateBack();
    }
    wx.miniProgram.switchTab({ url: "/pages/subscribe/subscribe" });
  } else {
    // 默认认为是app
    Ditto.openNative({
      protocol:
        "app://route/openNative?path=/subscription/subs&data=" +
        JSON.stringify({
          path: "/subscription/subs",
          type: "2",
        }),
    });
  }
};
onMounted(() => {
  // 加载支付宝sdk
  console.log('灰度发布验证')
  hasAliApp.value = navigator.userAgent.indexOf("AliApp") > -1;
  whiteLayout.value = !!route.query.whitelayout;
  hideQrcode.value = !!route.query.hideqrcode;
  // 因为支付宝小程序服务创建时如果在url上携带多个参数时仅保留一个参数,所以设置参数,如携带视为同时携带whitelayout与hideqrcode
  if (route.query.whiteandhideqr) {
    whiteLayout.value = true;
    hideQrcode.value = true;
  }
});
</script>
<style lang="scss" scoped>
::-webkit-scrollbar {
  display: none;
}
.bblayout {
  background: #0b0b0b;
  color: #fff;
  font-size: 22px;
  line-height: 36px;
}
.bblayout__content {
  padding-top: 40px;
  margin: 40px;
  background-color: #fff;
}
.guidelines__card {
  margin: 20px 30px;
  border-radius: 4px;
  background: #24292c;
  padding: 40px 32px;
  & > div + div {
    margin-top: 10px;
    word-wrap: break-word;
    word-break: break-all;
    text-align: justify;
  }
}
.guidelines__card-transparent {
  margin: 20px 65px;
}
.guidelines__table {
  margin: 20px 65px;
  img {
    width: 100%;
  }
}
.guidelines__qrcode {
  background-color: #f7f8f9;
  padding: 53px 65px 40px;
  text-align: center;
  font-size: 16px;
  white-space: nowrap;
  position: relative;
  img {
    width: 150px;
    height: 150px;
    margin-bottom: 40px;
  }
  &::after {
    content: "";
    display: block;
    width: 0;
    height: 0;
    border-top: 8px solid #F76400;
    border-left: 8px solid rgba(247, 100, 0, 0);
    border-right: 8px solid rgba(247, 100, 0, 0);
    position: absolute;
    left: 0;
    right: 0;
    margin: auto;
    bottom: 136px;
  }
}
.guidelines__title {
  font-weight: bold;
  margin: 40px auto 30px;
  font-size: 30px;
  line-height: 40px;
  text-align: center;
  & > div {
    padding: 0 10px;
    display: inline-block;
    position: relative;
    &::before {
      content: "";
      display: block;
      bottom: 3px;
      left: 0;
      right: 0;
      height: 12px;
      position: absolute;
      z-index: 1;
      background: linear-gradient(
        to right,
        rgba(247, 100, 0, 0.9),
        rgba(247, 100, 0, 0.1)
      );
    }
    &::after {
      content: attr(data-title);
      position: relative;
      z-index: 2;
    }
  }
}
.small-font {
  font-size: 18px;
}
.orange-font {
  color: #F76400;
}
.transparent-font {
  // opacity: 0.5;
  color: #777;
}
.bold-font {
  font-weight: bold;
}
.mgt {
  margin-top: 20px;
  width: 100%;
}
.has-blurbar {
  position: relative;
  padding-left: 15px;
  font-weight: bold;
  font-size: 24px;
  margin-bottom: 10px;
  &::before {
    content: "";
    width: 8px;
    display: block;
    position: absolute;
    background-color: #F76400;
    border-radius: 4px;
    top: 6px;
    bottom: 6px;
    left: 0;
  }
}
.guidelines__tab {
  margin: 0 65px;
  background: #24292c;
  border-radius: 22px;
  padding: 16px 34px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.guidelines__tabitem {
  color: rgb(255, 255, 255, 0.5);
  border: 1px solid rgb(255, 255, 255, 0.5);
  word-wrap: break-all;
  font-size: 22px;
  line-height: 32px;
  padding: 16px 12px;
  text-align: center;
  width: 15%;
  border-radius: 16px;
  box-sizing: border-box;
  &.guidelines__tabitem--active {
    color: #00cab7;
    border: 1px solid #00cab7;
  }
}
.guidelines__tosub {
  background-color: #f7f8f9;
  border: 1px solid #00cab7;
  color: #00cab7;
  font-weight: bold;
  height: 98px;
  width: 540px;
  margin: 0 auto;
  line-height: 98px;
  border-radius: 4px;
  font-size: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
  &::after {
    content: "";
    width: 16px;
    height: 16px;
    border-top: 2px solid #00cab7;
    border-right: 2px solid #00cab7;
    transform: rotate(45deg);
    margin-left: 10px;
  }
}
.guidelines__hint {
  padding: 65px 0;
  
  font-size: 18px;
}
// 支付宝白色底覆盖样式
.bblayout.white-layout {
  background-color: #f7f8f9;
  color: #232323;
  .guidelines__card,
  .guidelines__tab {
    background-color: #f7f8f9;
  }
  .guidelines__tabitem {
    border: 0;
    color: #7c7f80;
    font-weight: normal;
    &.guidelines__tabitem--active {
      font-weight: bold;
      color: #232323;
      background-color: #fff;
    }
  }
  .has-blurbar::before {
    background-color: #F76400;
  }
  .guidelines__tosub {
    color: #fff;
    border: none;
    background: linear-gradient(90deg, #515455 0%, #232323 100%);
    background-color: #f7f8f9;
    &::after {
      border-color: #fff;
    }
  }
}
.guidelines__btn{
  background-color: #f7f8f9;
  margin: 0;
}
</style>
